import { Injectable } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  constructor() { }

  /**
   * Used to show validation message.
   * @param formGroup 
   */
  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      if (control?.invalid) {
        control.markAsDirty({ onlySelf: true });
      }
      if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      } else if (control instanceof FormArray) {
        Object.keys(control.controls).forEach((subFields: any) => {
          const subcontrol = control.controls[subFields];
          if (subcontrol.invalid) {
            subcontrol.markAsDirty({ onlySelf: true });
          }
          if (subcontrol instanceof FormGroup) {
            this.validateAllFormFields(subcontrol);
          }
        });
      }
    });
  }
}
